import { useReducer, useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import { AuthReducer } from "./AuthReduces";
import { types } from "../types/types";
import { socketWex, setSocketsAgent } from "../../utils/Socket";

const init = () => {
  const sessionId = localStorage.getItem("sessionId");
  const payloadMaster = localStorage.getItem("payloadMaster");
  const payload = localStorage.getItem("payload");
  try {
    const user = payload ? JSON.parse(payload) : null;
    const master = payloadMaster ? JSON.parse(payloadMaster) : null;

    return {
      logged: !!user,
      payload: user,
      payloadMaster: master,
      sessionId,
    };
  } catch (error) {
    return {
      logged: false,
      payload: null,
      payloadMaster: null,
      sessionId: null,
    };
  }
};
export const AuthProvider = ({ children }) => {
  const [authState, dispatch] = useReducer(AuthReducer, {}, init);
  const tabId = localStorage.getItem("tabId") || Date.now().toString();
  localStorage.setItem("tabId", tabId);

  useEffect(() => {
    const checkTabId = () => {
      const storedTabId = localStorage.getItem("tabId");
      const payload = JSON.parse(localStorage.getItem("payload"));
      if (payload?.profile?.class === "_AGENT_") {
        localStorage.setItem("tabId", tabId);
      }
    };

    const handleStorageChange = (event) => {
      if (event.key === "tabId" && event.newValue !== tabId) {
        const payload = JSON.parse(localStorage.getItem("payload"));

        if (payload?.profile?.class === "_AGENT_") {
          localStorage.removeItem("tabId");
          window.location.reload();
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    checkTabId();

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [tabId]);

  useEffect(() => {
    const agentId = authState.payload?._id;
   
    // 🔴 NO hay agente → socket desconectado
    if (!agentId) {
      if (socketWex.connected) {
        socketWex.disconnect();
      }
      return;
    }
    // 🟢 Hay agente → auth + connect
    setSocketsAgent(agentId);
    if (!socketWex.connected) {
      socketWex.connect();
    }
    return () => {
      socketWex.off(); // limpieza defensiva
    };
  }, [authState.payload?._id]);
  

  const login = async (payload) => {
    const sessionId = Date.now().toString();
    localStorage.setItem("sessionId", sessionId);
    localStorage.setItem("payload", JSON.stringify(payload));
    localStorage.setItem("tabId", tabId);

    const action = {
      type: types.login,
      payload,
      sessionId,
    };

    dispatch(action);
  };

  const logout = async () => {
    if (socketWex.connected) {
      socketWex.disconnect();
    }
    localStorage.removeItem("payload");
    localStorage.removeItem("payloadMaster");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("tabId");

    const action = {
      type: types.logout,
    };

    dispatch(action);
  };

  const switchToUser = (userPayload) => {
    const currentPayload = localStorage.getItem("payload");

    // Solo guardar el payloadMaster si aún no está
    if (!localStorage.getItem("payloadMaster") && currentPayload) {
      localStorage.setItem("payloadMaster", currentPayload);
    }

    // Guardar el nuevo usuario (_idUser) como payload
    localStorage.setItem("payload", JSON.stringify(userPayload));
    if (socketWex.connected) {
      socketWex.disconnect();
    }
    const action = {
      type: types.switchToUser,
      payload: userPayload,
    };

    dispatch(action);
  };

  const restoreMaster = () => {
    const storedMaster = localStorage.getItem("payloadMaster");

    if (storedMaster) {
      localStorage.setItem("payload", storedMaster);
      localStorage.removeItem("payloadMaster");

      const action = {
        type: types.restoreMaster,
      };
      dispatch(action);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...authState,
        login,
        logout,
        switchToUser,
        restoreMaster,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
